'use client'
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { IGallery } from '@/_types'

const SingleGallery = ({ data }: { data: IGallery }) => {
  const isDesktop = useIsDesktop()
  return isDesktop ? <Desktop data={data} /> : <Mobile data={data} />
}

export default SingleGallery
